export default (number: number): string => {
  const m = number % 60
  const h = parseInt(String(number / 60))

  return (h > 9 ? h : '0' + h) + ':' + (m > 9 ? m : '0' + m)
}
